module.exports = __webpack_public_path__ + "img/betguide-3.3584d5a2.svg";